export type LessonTypeArg =
  | "auto"
  | "reading"
  | "listening"
  | "speaking"
  | "writing"
  | "grammar"
  | "vocabulary"
  | "functions_communication";

export const LESSON_TYPE_OPTIONS: {
  value: LessonTypeArg;
  label: string;
}[] = [
  { value: "auto", label: "Auto-detect" },
  { value: "reading", label: "Reading" },
  { value: "listening", label: "Listening" },
  { value: "speaking", label: "Speaking" },
  { value: "writing", label: "Writing" },
  { value: "grammar", label: "Grammar" },
  { value: "vocabulary", label: "Vocabulary" },
  {
    value: "functions_communication",
    label: "Functions & Communication",
  },
];
